import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { deriveTitleFromPath } from '@src/components/sco/utilities/SEOMetadata/seo-utils';
import { SiteSection } from '@src/contexts/ActiveContentContext';
import { startupsUrl } from '@src/lib/startups-url';
import { seoDefaults } from '@src/seo-defaults';
import { usePathname } from 'next/navigation';
export const SiteSectionSEO = props => {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname || $[1] !== props.siteSection) {
    let seoProps = {
      url: startupsUrl(pathname)
    };
    bb0: switch (props.siteSection) {
      case "about.overview":
        {
          seoProps.title = "About Us";
          seoProps.description = "We provide education and tools to walk aspiring founders through the entire startup process: from education to business planning, mentorship, customer acquisition, funding and staffing.";
          break bb0;
        }
      case "about.jobs":
        {
          seoProps.title = "About Our Work & Open Positions";
          seoProps.description = "Join the Startups.com team of over 170 people and help shape the future of startup courses, community, and software.";
          break bb0;
        }
      case "about.culture":
        {
          seoProps.title = "About our Culture";
          seoProps.description = "What would our dream job look like? We challenge ourselves to shape our culture around answering this question. And you know what? It works.";
          break bb0;
        }
      case "about.mission":
        {
          seoProps.title = "About our Mission";
          seoProps.description = "We provide education and tools to walk aspiring founders through the entire startup process: from education to business planning, mentorship, customer acquisition, funding and staffing.";
          break bb0;
        }
      case "articles.landing":
        {
          seoProps.title = "Articles - Expert Advice on How to Launch and Grow Your Startup";
          seoProps.description = "It's like the Wikipedia for startup advice, except all of that startup advice is coming from the smartest people who have ever built a startup and hand-edited so you only have to read the most interesting parts.";
          break bb0;
        }
      case "chat.landing":
        {
          seoProps.title = "Chat";
          seoProps.description = "Stay connected with our entire Founder network in real-time.";
          break bb0;
        }
      case "education.landing":
        {
          seoProps.title = "Education - Startup Business Courses, Videos, and Articles";
          seoProps.description = "Ridiculously comprehensive courses on every aspect of starting a company. From finding investors to acquiring customers to validating your idea. All at your fingertips.";
          break bb0;
        }
      case "events.group-meetings":
        {
          seoProps.title = "Group Meetings - Networking Events for Startup Founders";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.landing":
        {
          seoProps.title = "Events";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.public":
        {
          seoProps.title = "Public Events";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.my-events":
        {
          seoProps.title = "My Events";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.office-hours":
        {
          seoProps.title = "Office Hours - One-on-One Sessions with Startup Experts";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.office-hours.single":
        {
          seoProps.title = "Office Hours - One-on-One Sessions with Startup Experts";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.past":
        {
          seoProps.title = "Past Events";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.single":
        {
          seoProps.title = "Events";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "events.workshops":
        {
          seoProps.title = "Workshops - Mentorship and Networking for Startup Founders";
          seoProps.description = "Live workshops and community groups to connect with startup founders and experts who can help you launch your startup.";
          break bb0;
        }
      case "experts.landing":
      case "experts.single":
      case "experts.search":
        {
          seoProps.title = "Startup Experts and Advice";
          seoProps.description = "Get the answers to your business questions and receive trusted advice from our network of thousands of world-class startup experts and mentors.";
          break bb0;
        }
      case "founder-interviews.landing":
      case "founder-interviews.list":
      case "founder-interviews.search":
      case "founder-interviews.single":
        {
          seoProps.title = "Interviews - The Stories Behind Influential and Successful Startup Founders";
          seoProps.description = "Personal and candid one-on-one interviews with some of the most best startup founders including Elon Musk, Brian Chesky, Craig Newmark, and many more.";
          break bb0;
        }
      case "home.landing":
      case "requests.landing":
      case "tour.landing":
        {
          seoProps = {
            ...seoDefaults
          };
          break bb0;
        }
      case "funding.landing":
        {
          seoProps.title = "Raise Capital 10x Faster";
          seoProps.description = "Automate your fundraise with AI investor matching and outreach. Match with verified investors, perfect your pitch, and track every email in one place.";
          break bb0;
        }
      case "advisors":
      case "advisors.landing":
        {
          seoProps.title = "Startup Advisors & Wil.ai";
          seoProps.description = "The advice you need, the moment you need it. A 24/7 AI advisor blended with real-world experts for funding, pitch decks, customers, and product.";
          break bb0;
        }
      case "pitch-decks.landing":
        {
          seoProps.title = "Pitch Decks. Funded.";
          seoProps.description = "Stop guessing. Get an investor-grade audit of your pitch deck \u2014 scores, objections, and rewrites for the slides that cost you meetings.";
          break bb0;
        }
      case "landing.pitch-deck-audit":
        {
          seoProps.title = "Pitch Deck Auditor \u2014 an investor-grade audit of your deck";
          seoProps.description = "Upload your pitch deck and get a brutally honest, slide-by-slide audit: the investor objections, the fixes, suggested rewrites, and an AI coach to argue with. In about a minute.";
          break bb0;
        }
      case "investors.recommended":
      case "investors.messages.list":
      case "investors.messages.single":
      case "investors.saved":
      case "investors.search":
      case "investors.single":
        {
          seoProps.title = "Investor Database";
          seoProps.description = "Search a validated list of Startup Investors including Venture Capital, Angel Investors, and other funding sources.";
          break bb0;
        }
      case "landing.funding-accelerator":
        {
          seoProps.title = "Funding Accelerator";
          seoProps.description = "The most effective way to quickly raise capital for any startup - get a dedicated team of experts to help you raise capital, build your pitch deck, and find the most relevant investors.";
          break bb0;
        }
      case "landing.investor-outreach":
        {
          seoProps.title = "AI-Powered Investor Research and Outreach";
          seoProps.description = "The most effective way to quickly raise capital for any startup - get a dedicated team of experts to help you raise capital, build your pitch deck, and find the most relevant investors.";
          break bb0;
        }
      case "landing.investor-matching":
        {
          seoProps.title = "AI-Powered Investor Matching and Outreach";
          seoProps.description = "Raise capital 10x faster. Automate your fundraise with investor matching and outreach.";
          break bb0;
        }
      case "landing.funding-help":
        {
          seoProps.title = "Top Fundraising Resources for Startups";
          seoProps.description = "The most effective way to quickly raise capital for any startup - get the tools you need to raise capital, build your pitch deck, and pitch the most relevant investors.";
          break bb0;
        }
      case "landing.30-day-plan":
        {
          seoProps.title = "Get Your Free 30-Day Startup Plan";
          seoProps.description = "Get your 30-day startup plan for free. Learn how to build a successful startup in just 30 days with our comprehensive guide.";
          break bb0;
        }
      case "landing.capital-compass":
        {
          seoProps.title = "Capital Compass \u2013 Find the Right Investors For Your Startup";
          seoProps.description = "Capital Compass helps startup founders identify the best investor types for their stage, industry, and goals.";
          break bb0;
        }
      case "landing.funding-readiness":
        {
          seoProps.title = "Are You Ready For Funding?";
          seoProps.description = "Is your startup ready for funding? Let's assess your fundraising readiness and identify the best investor types for your startup.";
          break bb0;
        }
      case "legal.guarantee":
        {
          seoProps.title = "Our Guarantee to Members";
          seoProps.description = "";
          break bb0;
        }
      case "legal.privacy":
        {
          seoProps.title = "Privacy Policy";
          seoProps.description = "Our policies regarding user privacy and data rights.";
          break bb0;
        }
      case "legal.tos":
        {
          seoProps.title = "Terms of Service";
          seoProps.description = "Our policies regarding use of our platform and sites.";
          break bb0;
        }
      case "login":
        {
          seoProps.title = "Login";
          seoProps.description = "Login to your Startups.com account.";
          break bb0;
        }
      case "funding-accelerator.rac":
        {
          seoProps.title = "Request a Consultation - Funding Accelerator";
          seoProps.description = "Request more information about the Startups.com Funding Accelerator.";
          break bb0;
        }
      case "funding-accelerator.payment":
        {
          seoProps.title = "Join the Funding Accelerator";
          seoProps.description = "Accelerator your fundraise with guided advice, a perfected pitch deck, and access to all the resources needed to close your funding round.";
          break bb0;
        }
      case "members.search":
      case "members.single":
        {
          seoProps.title = "Members";
          seoProps.description = "Connect with other founders.";
          break bb0;
        }
      case "notifications.list":
      case "notifications.single":
        {
          seoProps.title = "Notifications";
          seoProps.description = "Updates about relevant activity on Startups.com";
          break bb0;
        }
      case "onboarding.get-involved":
        {
          seoProps.title = "Get Involved - Account Setup";
          break bb0;
        }
      case "onboarding.goals":
        {
          seoProps.title = "Your Goals - Account Setup";
          break bb0;
        }
      case "onboarding.intro-call":
        {
          seoProps.title = "Schedule Your Intro Call - Account Setup";
          break bb0;
        }
      case "onboarding.profile":
        {
          seoProps.title = "Your Profile - Account Setup";
          break bb0;
        }
      case "onboarding.sprint":
        {
          seoProps.title = "Choose a Sprint - Account Setup";
          break bb0;
        }
      case "onboarding.startup":
        {
          seoProps.title = "Your Startup - Account Setup";
          break bb0;
        }
      case "onboarding.welcome":
        {
          seoProps.title = "Welcome - Account Setup";
          break bb0;
        }
      case "perks.landing":
      case "perks.partners.landing":
      case "perks.partners.single":
        {
          seoProps.title = "Deals and Discounts on Tools for Startups";
          seoProps.description = "Save thousands of dollars on all of the startup services you need with a Startups Unlimited Membership.";
          break bb0;
        }
      case "playbooks.single.phase":
      case "playbooks.single":
      case "playbooks.landing":
        {
          seoProps.title = "Step-by-step instruction on how to build a startup.";
          seoProps.description = "Learn through comprehensive, guided playbooks how to validate your startup idea, acquire your first customers, and secure funding.";
          break bb0;
        }
      case "podcast.landing":
      case "podcast.search":
      case "podcast.single":
        {
          seoProps.title = "Startup Therapy Podcast";
          seoProps.description = "We dive deep into the problems startup Founders face every day to unpack what's really at stake and how to actually solve them.";
          break bb0;
        }
      case "posts.landing":
      case "posts.search":
      case "posts.single":
        {
          seoProps.title = "Expert Answers";
          seoProps.description = "Get the answers to your startup questions and receive trusted advice from our network of thousands of world-class startup experts and founders.";
          break bb0;
        }
      case "questions.landing":
      case "questions.single":
        {
          seoProps.title = "Small Business Questions and Answers from Experts";
          seoProps.description = "Get the answers to your business questions and receive trusted advice from our network of thousands of world-class startup experts and mentors.";
          break bb0;
        }
      case "signup.register":
        {
          seoProps.title = "Create an Account";
          break bb0;
        }
      case "signup.profile":
        {
          seoProps.title = "Account Profile";
          break bb0;
        }
      case "signup.plans":
        {
          seoProps.title = "Membership Plans";
          break bb0;
        }
      case "signup.payment":
        {
          seoProps.title = "Start Your Membership";
          break bb0;
        }
      case "investor-outreach.register":
        {
          seoProps.title = "Create an Account | Investor Outreach";
          break bb0;
        }
      case "investor-outreach.pitch-deck":
        {
          seoProps.title = "Upload Pitch Deck | Investor Outreach";
          break bb0;
        }
      case "investor-outreach.payment":
        {
          seoProps.title = "Payment | Investor Outreach";
          break bb0;
        }
      case "investor-outreach.submitted":
        {
          seoProps.title = "Submitted | Investor Outreach";
          break bb0;
        }
      case "investor-matching":
        {
          seoProps.title = "Investor Matching";
          break bb0;
        }
      case "sprints.landing":
      case "sprints.track":
      case "sprints.track.section":
      case "sprints.track.section.step":
      case "sprints.track.section.step.task":
        {
          seoProps.title = "Sprints";
          seoProps.description = "Sprints";
          break bb0;
        }
      case "videos.landing":
      case "videos.search":
        {
          seoProps.title = "Startup Videos by World-Class Experts";
          seoProps.description = "Learn the best practices of entrepreneurship from world-class experts in over 650 short videos.";
          break bb0;
        }
      case "videos.series":
      case "videos.series.lesson":
        {
          seoProps.title = deriveTitleFromPath(pathname);
          seoProps.description = "Learn the best practices of entrepreneurship from world-class experts in over 650 short videos.";
          break bb0;
        }
      default:
        {
          seoProps = {};
        }
    }
    seoProps.imageUrl = startupsUrl("/api/og-image", {
      title: seoProps.title,
      description: seoProps.description
    });
    t0 = <SEOMetadata {...seoProps} />;
    $[0] = pathname;
    $[1] = props.siteSection;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};